import { render, staticRenderFns } from "./DisplayCurrencyPrice.vue?vue&type=template&id=265bde9f&"
import script from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js&"
export * from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports